<template>
  <div class="playlist-table-mobile-info">
    <a class="link" title="link" @click="linkOnClick">
      <div v-if="track" class="subject">
        <span class="composer">
          {{ displayComposerName(track.movement.work.people) }}
        </span>
        <span v-if="track.movement">
          -
        </span>
        <span class="name">
          {{ displayTrackName(track) }}
        </span>
      </div>
      <div v-if="track" class="perform">
        <span class="performer-list">
          <span v-for="(performer, index) in filteredPerformerList" :key="performer.people_id">
            {{ displayPerformerName(performer.people) }}
            <span v-if="performer.people && (index < filteredPerformerList.length - 1)" class="slash">
              /
            </span>
          </span>
        </span>
      </div>
    </a>
  </div>
</template>
<script>
import { displayTrackName, displayComposerName, displayPerformerName, displayPerformerPosition } from '@/assets/helpers/TrackHelper.js'

export default {
  name: 'PlaylistTableMobileInfo',
  components: {},
  props: {
    track: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {
    performerList() {
      return this.track.performers || []
    },
    filteredPerformerList() {
      let existIdAry = []
      return this.performerList.filter(performer => {
        if (existIdAry.indexOf(performer.people_id) === -1) {
          existIdAry.push(performer.people_id)
          return performer
        }
        return null
      })
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    displayTrackName,
    displayComposerName,
    displayPerformerName,
    displayPerformerPosition,
    linkOnClick(index) {
      if (window.innerWidth < 768) {
        // play ?
        this.$router.push({ name: 'trackById', params: { id: this.track.id } })
      } else {
        this.$router.push({ name: 'trackById', params: { id: this.track.id } })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.playlist-table-mobile-info {

  .link {
    display: inline-block;
    max-width: 100%;
    .subject,
    .perform {
      width: 100%;
      @include ellipsis-with-nowrap();
    }
    .subject {
      height: 26px;
      font-size: 16px;
      font-weight: 700;
      line-height: 1.63; // 26px
      color: $grey-7d;
    }
    .perform {
      height: 18px;
      font-size: 12px;
      font-weight: 500;
      line-height: 1.5; // 18px
      color: $grey-9b;
    }
    @media (hover:hover) {
      cursor: pointer;
      &:hover {
        .subject,
        .perform {
          color: $link-hover;
        }
      }
    }
  }
}

@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}

</style>
